import { timestampsMap } from "./timestamps";

export const userMap: GenericObject = {
	nome: "name",
	sexo: "sex",
	matricula: "login",
	numero_conselho: "councilNumber",
	cpf: "identifier",
	cns: "nationalHealthCard",
	ativado: "active",
	imgperfil: "avatar",
	telefone: "telephone",
	data_nasc: "birthdate",
	autenticador: "authenticator",
	unidade_id: "unitId",
	cep: "zipCode",
	pais: "country",
	uf: "state",
	cidade: "city",
	tipo_logradouro: "addressType",
	lougradouro: "address",
	numero: "number",
	complemento: "complement",
	bairro: "neighborhood",
	unidade: "unit",
	crm: "rcm",
	cod_cartao: "cardCode",
	codprofcnes: "profesionalCode",
	vinculo: "attachment",
	cbo: "bco",
	profile_logado: "loggedProfile",
	mobile_access: "mobileAccess",
	especialidade_id: "expertiseId",
	last_seen: "lastSeen",
	last_session_id: "lastSessionId",
	last_modified_admin_id: "lastModifiedAdminId",
	notificacao: "notification",
	setor_id: "departmentId",
	...timestampsMap,
};
